/**
 * HeavyProgressBar — barra de progreso "Heavy Bar" de la identidad v2.1:
 * surco troquelado con sombra interior, relleno acero→bronce y muescas de
 * medición cada 10 %.
 *
 * value — 0..100. label/right — textos opcionales arriba de la barra.
 * failed — relleno en rojo cobre. size — 'sm' | 'md'.
 */
const HeavyProgressBar = ({ value = 0, label, right, failed = false, size = 'md', className = '', testid }) => {
  const pct = Math.max(0, Math.min(100, Number(value) || 0));
  const h = size === 'sm' ? 'h-2' : 'h-3.5';
  return (
    <div className={`w-full ${className}`} data-testid={testid}>
      {(label || right) && (
        <div className="flex items-center justify-between text-[11px] mb-1 font-display uppercase tracking-wider">
          <span className="text-zinc-300">{label}</span>
          {right && <span className="text-zinc-500 tabular-nums">{right}</span>}
        </div>
      )}
      <div
        className={`relative ${h} rounded-sm overflow-hidden border border-zinc-700`}
        style={{ background: '#0B0C0E', boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.7), inset 0 -1px 0 rgba(255,255,255,0.04)' }}
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={Math.round(pct)}
      >
        <div
          className="h-full transition-[width] duration-slow ease-out-atl"
          style={{
            width: `${pct}%`,
            background: failed
              ? 'linear-gradient(90deg, #5A2424 0%, #7E2A2A 100%)'
              : 'linear-gradient(90deg, #585F6B 0%, #E5E9F0 70%, #9A6647 100%)',
            boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.25)',
          }}
        />
        {/* muescas cada 10 % */}
        {Array.from({ length: 9 }, (_, i) => (
          <span
            key={i}
            aria-hidden="true"
            className="absolute top-0 bottom-0 w-px"
            style={{ left: `${(i + 1) * 10}%`, background: 'rgba(11,12,14,0.65)' }}
          />
        ))}
      </div>
    </div>
  );
};

export default HeavyProgressBar;
